import React from 'react';
// import PropTypes from 'prop-types'
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { enableAnalytics, getMixPanelToken } from 'configs';
import { IntlProvider } from 'react-intl';
import { createLocalizeApp } from 'i18n/i18nConfig';
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel';

// To be able to change routes using history.push outside
// of a react component, i.e. in a redux action,
// we need to expose the history object
// eslint-disable-next-line max-len
// https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components
import { initializeAnalytics } from './analytics/ReactGA'; // All things analytics
import history from './legacy/containers/History';
import {
  checkAuthentication,
  intervalAuthenticationChecker,
  clearIntervalAuthenticationChecker,
} from './legacy/containers/Auth';
import store from './state/appStore';
import { checkForOutdatedBrowser } from './legacy/store/appReducer';
import { appRoot } from './legacy/constants';
import RouteManager from './views/RouteManager';

// import '!style-loader!css-loader!react-select/dist/react-select.css'
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!react-date-range/dist/styles.css';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!react-date-range/dist/theme/default.css';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!react-virtualized/styles.css';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!react-toastify/dist/ReactToastify.css';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!./styles/overrideReactToastify.css';
import 'rheostat/initialize';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!rheostat/css/rheostat.css';
// eslint-disable-next-line import/no-unresolved,import/no-webpack-loader-syntax
import '!style-loader!css-loader!./legacy/styles/thirdPartyCssOverrides.css';
import './index.css';

if (store.dispatch(checkAuthentication())) {
  store.dispatch(intervalAuthenticationChecker());
}

const handleBeforeUnloadEvent = () => clearIntervalAuthenticationChecker();
window.addEventListener('beforeunload', handleBeforeUnloadEvent);

store.dispatch(checkForOutdatedBrowser());
if (enableAnalytics()) {
  initializeAnalytics('UA-33470753-6', 'app-root');
}

// https://github.com/TryGhost/Ghost/issues/7934#issuecomment-349795002
// https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
if (store.getState().app.browser.name === 'chrome') {
  window.addEventListener('mousewheel', e => {
    if (e.deltaY === 1) {
      e.preventDefault();
    }
  });
}

mixpanel.init(getMixPanelToken());
createLocalizeApp((i18nAppData, bundle) => {
  ReactDOM.render(
    <IntlProvider
      locale={i18nAppData.locale}
      timeZone={i18nAppData.tz}
      messages={bundle}
    >
      <MixpanelProvider mixpanel={mixpanel}>
        <Provider store={store}>
          {/* Using low level router to use history directly */}
          <Router history={history}>
            <RouteManager />
          </Router>
        </Provider>
      </MixpanelProvider>
    </IntlProvider>,
    appRoot,
  );
});



// WEBPACK FOOTER //
// ./src/index.jsx